module.exports = __webpack_public_path__ + "img/ic_logo_toolkit_58dp.1e8cee6d.png";